// MessageDetailLayoutSelector.js
'use strict';
'use client';
import { connect } from 'react-redux';

import MessageDetailLayoutSelector from '../component/MessageDetailLayoutSelector.jsx';

import withRouter from '../component/WithRouter.jsx';

import getOperationData from '../selector/getOperationData.js';
import getMessageData from '../selector/getMessageData.js';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = (
  state,
  {
    match: {
      params: { messageId },
    },
  }
) => {
  return {
    messageId,
    meId: getMeData(state, 'id'),
    senderId: getMessageData(state, messageId, 'senderId'),
    deviceHeight: getOperationData(state, ['device'], 'height'),
    isPublished: getMessageData(state, messageId, 'isPublished'),
  };
};

export default withRouter(
  connect(mapStateToProps)(MessageDetailLayoutSelector)
);
